<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card color="kbWhite">
        <v-dialog v-model="showDialog" max-width="400px" persistent>
            <v-card class="error">
                <v-card-text>
                    <v-row>
                        <v-col class="text-center pa-4" cols="12" >
                            <v-icon color="white" size="60">warning</v-icon>
                        </v-col>

                        <v-col cols="12" class="white--text text-center px-2" >
                            {{$t('general.changingPublicKeyWillAffectApps')}}
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-center">
                    <v-btn text color="white" @click="showDialog = false">{{$t('general.cancel')}}</v-btn>
                    <v-btn outlined color="white" @click="generateKeys()" :loading="loading">{{$t('general.accept')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card-title class="text-h6">
            <span class="pt-2 kbDarkBlueText--text">{{$t('general.apiKey')}}</span>
        </v-card-title>

        <v-list two-line color="kbWhite">
            <a href="https://admin.keybe.bio/apidocs/" target="_blank" style="text-decoration: none;">
                <v-list-item link>
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-icon color="kbDarkBlueText" left>link</v-icon>
                            {{$t('general.goToApiDoc')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </a>

            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        {{selectedApp.UUID}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        App ID
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn icon text color="primary" @click="copyText(selectedApp.UUID)">
                        <v-icon color="kbGray">file_copy</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        {{selectedCompany.UUID}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        Company ID
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn icon text color="primary" @click="copyText(selectedCompany.UUID)">
                        <v-icon color="kbGray">file_copy</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        {{selectedApp.client_key}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        Keybe UI
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn icon text color="primary" @click="copyText(selectedApp.client_key)">
                        <v-icon color="kbGray">file_copy</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="red--text" v-if="messageError">
                        {{messageError}}
                    </v-list-item-title>

                    <v-list-item-title v-else>
                        {{publicKey}}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                        {{$t('general.publicKey')}}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn color="kbLightBlue"
                           dark
                           v-if="messageError"
                           :loading="loading"
                           @click="generateKeys()">
                        {{$t('general.generate')}}
                    </v-btn>

                    <span v-if="publicKey">
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <v-btn v-on="on" icon right text color="primary" @click="showDialog = true">
                                    <v-icon>autorenew</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('general.reNewPublicKey')}}</span>
                        </v-tooltip>

                        <v-btn icon text color="primary" @click="copyText(publicKey)">
                            <v-icon>file_copy</v-icon>
                        </v-btn>
                    </span>

                </v-list-item-action>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp,
      selectedCompany: state => state.companies.selectedCompany
    })
  },
  created () {
    this.getPublicKey()
  },
  data () {
    return {
      loading: false,
      messageError: '',
      publicKey: '',
      showDialog: false
    }
  },
  methods: {
    copyText (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success(this.$t('general.apiKeyCopied'))
      }).catch(() => {
        notifications.error(this.$t('general.apiKeyCopyError'))
      })
    },
    generateKeys () {
      this.loading = true
      this.$store.dispatch('generateKeys', { genPublicKey: true, genPrivateKey: false }).then(response => {
        this.loading = false
        this.publicKey = response.publicKey
        this.messageError = ''
        this.showDialog = false
        notifications.success(this.$t('general.publicKeyUpdated'))
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    getPublicKey () {
      this.$store.dispatch('getPublicKey').then(response => {
        this.messageError = ''
        this.publicKey = response.publicKey
      }).catch(error => {
        this.messageError = error.message
      })
    }
  }
}
</script>
